var map = {
	"./activities/elections/election_post/da.yml": 382,
	"./activities/elections/election_post/en.yml": 383,
	"./activities/index/card/da.yml": 384,
	"./activities/index/card/description/da.yml": 385,
	"./activities/index/card/description/en.yml": 386,
	"./activities/index/card/en.yml": 387,
	"./activities/index/da.yml": 388,
	"./activities/index/en.yml": 389,
	"./activities/link_cards/index/da.yml": 390,
	"./activities/link_cards/index/en.yml": 391,
	"./activities/register_button/da.yml": 392,
	"./activities/register_button/en.yml": 393,
	"./activities/regret_unregister_button/da.yml": 394,
	"./activities/regret_unregister_button/en.yml": 395,
	"./activities/show/da.yml": 396,
	"./activities/show/en.yml": 397,
	"./activities/show/politics/da.yml": 398,
	"./activities/show/politics/en.yml": 399,
	"./admin/abilities/table/da.yml": 400,
	"./admin/abilities/table/en.yml": 401,
	"./admin/ability_group_abilities/lock_icon/da.yml": 402,
	"./admin/ability_group_abilities/lock_icon/en.yml": 403,
	"./admin/ability_groups/edit/da.yml": 404,
	"./admin/ability_groups/edit/en.yml": 405,
	"./admin/ability_groups/table/da.yml": 406,
	"./admin/ability_groups/table/en.yml": 407,
	"./admin/activities/activities_nav/da.yml": 408,
	"./admin/activities/activities_nav/en.yml": 409,
	"./admin/activities/billing/da.yml": 410,
	"./admin/activities/billing/en.yml": 411,
	"./admin/activities/children/da.yml": 412,
	"./admin/activities/children/en.yml": 413,
	"./admin/activities/create_card/expandable_content/da.yml": 414,
	"./admin/activities/create_card/expandable_content/en.yml": 415,
	"./admin/activities/create_card/surveys_card/da.yml": 416,
	"./admin/activities/create_card/surveys_card/en.yml": 417,
	"./admin/activities/edit/da.yml": 418,
	"./admin/activities/edit/en.yml": 419,
	"./admin/activities/index/da.yml": 420,
	"./admin/activities/index/en.yml": 421,
	"./admin/activities/live/agenda/item_types/election/election_post/da.yml": 422,
	"./admin/activities/live/agenda/item_types/election/election_post/en.yml": 423,
	"./admin/activities/live/agenda/item_types/election/election_post_card/da.yml": 424,
	"./admin/activities/live/agenda/item_types/election/election_post_card/en.yml": 425,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/da.yml": 426,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/en.yml": 427,
	"./admin/activities/live/agenda/item_types/election/index/da.yml": 428,
	"./admin/activities/live/agenda/item_types/election/index/en.yml": 429,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/da.yml": 430,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/en.yml": 431,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/da.yml": 432,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/en.yml": 433,
	"./admin/activities/live/agenda/item_types/speaker_list/da.yml": 434,
	"./admin/activities/live/agenda/item_types/speaker_list/en.yml": 435,
	"./admin/activities/live_nav/da.yml": 436,
	"./admin/activities/live_nav/en.yml": 437,
	"./admin/activities/nav/da.yml": 438,
	"./admin/activities/nav/en.yml": 439,
	"./admin/activities/participants/da.yml": 440,
	"./admin/activities/participants/en.yml": 441,
	"./admin/activities/participants/index/da.yml": 442,
	"./admin/activities/participants/index/en.yml": 443,
	"./admin/activities/politics/proposals/da.yml": 444,
	"./admin/activities/politics/proposals/en.yml": 445,
	"./admin/activities/surveys/da.yml": 446,
	"./admin/activities/surveys/en.yml": 447,
	"./admin/activities/table/da.yml": 448,
	"./admin/activities/table/en.yml": 449,
	"./admin/activity_groups/create_card/da.yml": 450,
	"./admin/activity_groups/create_card/en.yml": 451,
	"./admin/activity_participant_type_rules/create_card/da.yml": 452,
	"./admin/activity_participant_type_rules/create_card/en.yml": 453,
	"./admin/activity_participant_type_rules/table/da.yml": 454,
	"./admin/activity_participant_type_rules/table/en.yml": 455,
	"./admin/activity_participants/expandable_content/da.yml": 456,
	"./admin/activity_participants/expandable_content/en.yml": 457,
	"./admin/activity_participants/index/da.yml": 458,
	"./admin/activity_participants/index/en.yml": 459,
	"./admin/activity_participants/invite/da.yml": 460,
	"./admin/activity_participants/invite/en.yml": 461,
	"./admin/activity_participants/requested_unregister/da.yml": 462,
	"./admin/activity_participants/requested_unregister/en.yml": 463,
	"./admin/activity_participants/table/da.yml": 464,
	"./admin/activity_participants/table/en.yml": 465,
	"./admin/activity_surveys/edit/da.yml": 466,
	"./admin/activity_surveys/edit/en.yml": 467,
	"./admin/activity_surveys/table/da.yml": 468,
	"./admin/activity_surveys/table/en.yml": 469,
	"./admin/agenda_item_element_speakers/create_card/da.yml": 470,
	"./admin/agenda_item_element_speakers/create_card/en.yml": 471,
	"./admin/agenda_item_element_speakers/table/da.yml": 472,
	"./admin/agenda_item_element_speakers/table/en.yml": 473,
	"./admin/agenda_item_elements/create_card/da.yml": 474,
	"./admin/agenda_item_elements/create_card/en.yml": 475,
	"./admin/agenda_items/create_card/da.yml": 476,
	"./admin/agenda_items/create_card/en.yml": 477,
	"./admin/agendas/create_card/da.yml": 478,
	"./admin/agendas/create_card/en.yml": 479,
	"./admin/agendas/live_button/da.yml": 480,
	"./admin/agendas/live_button/en.yml": 481,
	"./admin/bank_accounts/bank_account_modal/da.yml": 482,
	"./admin/bank_accounts/da.yml": 483,
	"./admin/bank_accounts/en.yml": 484,
	"./admin/bank_accounts/table/da.yml": 485,
	"./admin/bank_accounts/table/en.yml": 486,
	"./admin/bundle_photo_product/create_card/da.yml": 487,
	"./admin/bundle_photo_product/create_card/en.yml": 488,
	"./admin/bundles/edit/da.yml": 489,
	"./admin/bundles/edit/en.yml": 490,
	"./admin/bundles/select/da.yml": 491,
	"./admin/bundles/select/en.yml": 492,
	"./admin/bundles/show/da.yml": 493,
	"./admin/bundles/show/en.yml": 494,
	"./admin/call_list_entities/table/da.yml": 495,
	"./admin/call_list_entities/table/en.yml": 496,
	"./admin/call_lists/call_mode/call_list_entity_carousel/da.yml": 497,
	"./admin/call_lists/call_mode/call_list_entity_carousel/en.yml": 498,
	"./admin/call_lists/call_mode/index/da.yml": 499,
	"./admin/call_lists/call_mode/index/en.yml": 500,
	"./admin/call_lists/edit/da.yml": 501,
	"./admin/call_lists/edit/en.yml": 502,
	"./admin/call_lists/index/da.yml": 503,
	"./admin/call_lists/index/en.yml": 504,
	"./admin/call_lists/show/call_list_carousel/index/da.yml": 505,
	"./admin/call_lists/show/call_list_carousel/index/en.yml": 506,
	"./admin/call_lists/show/table/da.yml": 507,
	"./admin/call_lists/show/table/en.yml": 508,
	"./admin/call_lists/table/da.yml": 509,
	"./admin/call_lists/table/en.yml": 510,
	"./admin/comments/da.yml": 511,
	"./admin/comments/en.yml": 512,
	"./admin/comments/expanded_content_partial/da.yml": 513,
	"./admin/comments/expanded_content_partial/en.yml": 514,
	"./admin/comments/index/da.yml": 515,
	"./admin/comments/index/en.yml": 516,
	"./admin/communication/bottom_bar/da.yml": 517,
	"./admin/communication/bottom_bar/en.yml": 518,
	"./admin/communication/index/da.yml": 519,
	"./admin/communication/index/en.yml": 520,
	"./admin/communication/templates/da.yml": 521,
	"./admin/communication/templates/en.yml": 522,
	"./admin/competition_surveys/edit/da.yml": 523,
	"./admin/competition_surveys/edit/en.yml": 524,
	"./admin/competition_surveys/surveys/da.yml": 525,
	"./admin/competition_surveys/surveys/en.yml": 526,
	"./admin/competitions/edit/da.yml": 527,
	"./admin/competitions/edit/en.yml": 528,
	"./admin/competitions/form/da.yml": 529,
	"./admin/competitions/form/en.yml": 530,
	"./admin/competitions/index/da.yml": 531,
	"./admin/competitions/index/en.yml": 532,
	"./admin/competitions/surveys/da.yml": 533,
	"./admin/competitions/surveys/en.yml": 534,
	"./admin/components/photo_session_csvs/table/da.yml": 535,
	"./admin/components/photo_session_csvs/table/en.yml": 536,
	"./admin/components/photos/index/bottom_bar/da.yml": 537,
	"./admin/components/photos/index/bottom_bar/en.yml": 538,
	"./admin/components/sheet_layout_boxes/form/da.yml": 539,
	"./admin/components/sheet_layout_boxes/form/en.yml": 540,
	"./admin/contact_associates/create_card/da.yml": 541,
	"./admin/contact_associates/create_card/en.yml": 542,
	"./admin/contact_group_contacts/create_modal/da.yml": 543,
	"./admin/contact_group_contacts/create_modal/en.yml": 544,
	"./admin/contact_relationships/edit/da.yml": 545,
	"./admin/contact_relationships/edit/en.yml": 546,
	"./admin/contacts/anonymize_button/da.yml": 547,
	"./admin/contacts/anonymize_button/en.yml": 548,
	"./admin/contacts/convert_organization_to_person_button/da.yml": 549,
	"./admin/contacts/convert_organization_to_person_button/en.yml": 550,
	"./admin/contacts/edit/billing_contact/da.yml": 551,
	"./admin/contacts/edit/billing_contact/en.yml": 552,
	"./admin/contacts/edit/da.yml": 553,
	"./admin/contacts/edit/email/da.yml": 554,
	"./admin/contacts/edit/email/en.yml": 555,
	"./admin/contacts/edit/en.yml": 556,
	"./admin/contacts/edit/historical_data_card/da.yml": 557,
	"./admin/contacts/edit/historical_data_card/en.yml": 558,
	"./admin/contacts/edit/organization_content/da.yml": 559,
	"./admin/contacts/edit/organization_content/en.yml": 560,
	"./admin/contacts/edit/relationships/da.yml": 561,
	"./admin/contacts/edit/relationships/en.yml": 562,
	"./admin/contacts/edit/school_content/da.yml": 563,
	"./admin/contacts/edit/school_content/en.yml": 564,
	"./admin/contacts/edit/student_council_content/da.yml": 565,
	"./admin/contacts/edit/student_council_content/en.yml": 566,
	"./admin/contacts/edit/supplier_content/da.yml": 567,
	"./admin/contacts/edit/supplier_content/en.yml": 568,
	"./admin/contacts/index/bottom_bar/add_to_activity/da.yml": 569,
	"./admin/contacts/index/bottom_bar/add_to_activity/en.yml": 570,
	"./admin/contacts/index/bottom_bar/da.yml": 571,
	"./admin/contacts/index/bottom_bar/en.yml": 572,
	"./admin/contacts/index/da.yml": 573,
	"./admin/contacts/index/en.yml": 574,
	"./admin/contacts/index/expandable_content/da.yml": 575,
	"./admin/contacts/index/expandable_content/en.yml": 576,
	"./admin/contacts/index/filter_content/da.yml": 577,
	"./admin/contacts/index/filter_content/en.yml": 578,
	"./admin/contacts/index/old_nemoa_filter/da.yml": 579,
	"./admin/contacts/index/old_nemoa_filter/en.yml": 580,
	"./admin/contacts/link/da.yml": 581,
	"./admin/contacts/link/en.yml": 582,
	"./admin/contacts/merge/da.yml": 583,
	"./admin/contacts/merge/en.yml": 584,
	"./admin/contacts/relations/da.yml": 585,
	"./admin/contacts/relations/en.yml": 586,
	"./admin/contacts/show/create_user_modal/da.yml": 587,
	"./admin/contacts/show/create_user_modal/en.yml": 588,
	"./admin/contacts/show/da.yml": 589,
	"./admin/contacts/show/economy_and_integrations/da.yml": 590,
	"./admin/contacts/show/economy_and_integrations/en.yml": 591,
	"./admin/contacts/show/en.yml": 592,
	"./admin/contacts/show/historical_data_card/da.yml": 593,
	"./admin/contacts/show/historical_data_card/en.yml": 594,
	"./admin/contacts/show/memberships/add_subscription_card/da.yml": 595,
	"./admin/contacts/show/memberships/add_subscription_card/en.yml": 596,
	"./admin/contacts/show/nav/da.yml": 597,
	"./admin/contacts/show/nav/en.yml": 598,
	"./admin/contacts/show/organization_further_information_card/da.yml": 599,
	"./admin/contacts/show/organization_further_information_card/en.yml": 600,
	"./admin/contacts/show/organization_general_information_card/da.yml": 601,
	"./admin/contacts/show/organization_general_information_card/en.yml": 602,
	"./admin/contacts/show/person/surveys_nav/da.yml": 603,
	"./admin/contacts/show/person/surveys_nav/en.yml": 604,
	"./admin/contacts/show/person/user_teams/da.yml": 605,
	"./admin/contacts/show/person/user_teams/en.yml": 606,
	"./admin/contacts/show/person_general_information_card/da.yml": 607,
	"./admin/contacts/show/person_general_information_card/en.yml": 608,
	"./admin/contacts/show/realtions/da.yml": 609,
	"./admin/contacts/show/realtions/en.yml": 610,
	"./admin/contacts/show/relations/da.yml": 611,
	"./admin/contacts/show/relations/en.yml": 612,
	"./admin/contacts/show/school_information_card/da.yml": 613,
	"./admin/contacts/show/school_information_card/en.yml": 614,
	"./admin/contacts/show/student_council_information_card/da.yml": 615,
	"./admin/contacts/show/student_council_information_card/en.yml": 616,
	"./admin/contacts/show/uni_c/da.yml": 617,
	"./admin/contacts/show/uni_c/en.yml": 618,
	"./admin/contacts/show/user/da.yml": 619,
	"./admin/contacts/show/user/en.yml": 620,
	"./admin/contacts/status_select/da.yml": 621,
	"./admin/contacts/status_select/en.yml": 622,
	"./admin/contacts/update_number_of_students_from_csv/da.yml": 623,
	"./admin/contacts/update_number_of_students_from_csv/en.yml": 624,
	"./admin/economy/account_dimensions/da.yml": 625,
	"./admin/economy/account_dimensions/en.yml": 626,
	"./admin/economy/accounts/da.yml": 627,
	"./admin/economy/accounts/en.yml": 628,
	"./admin/economy/accounts/index/da.yml": 629,
	"./admin/economy/accounts/index/en.yml": 630,
	"./admin/economy/dimensions/da.yml": 631,
	"./admin/economy/dimensions/en.yml": 632,
	"./admin/economy/dimensions/index/da.yml": 633,
	"./admin/economy/dimensions/index/en.yml": 634,
	"./admin/economy/dimensions/locked_dimensions/da.yml": 635,
	"./admin/economy/employees/da.yml": 636,
	"./admin/economy/employees/en.yml": 637,
	"./admin/economy/index/da.yml": 638,
	"./admin/economy/index/en.yml": 639,
	"./admin/economy/invoices/da.yml": 640,
	"./admin/economy/invoices/en.yml": 641,
	"./admin/economy/nav/da.yml": 642,
	"./admin/economy/nav/en.yml": 643,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/da.yml": 644,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/en.yml": 645,
	"./admin/economy/subscription_renewal_generations/da.yml": 646,
	"./admin/economy/subscription_renewal_generations/en.yml": 647,
	"./admin/election_posts/table/da.yml": 648,
	"./admin/election_posts/table/en.yml": 649,
	"./admin/element_feedback/da.yml": 650,
	"./admin/element_feedback/en.yml": 651,
	"./admin/elements/edit/da.yml": 652,
	"./admin/elements/edit/en.yml": 653,
	"./admin/elements/show/da.yml": 654,
	"./admin/elements/show/en.yml": 655,
	"./admin/elements/table/da.yml": 656,
	"./admin/elements/table/en.yml": 657,
	"./admin/emails/admin_confirm_button/da.yml": 658,
	"./admin/emails/admin_confirm_button/en.yml": 659,
	"./admin/employee_prices/create_card/da.yml": 660,
	"./admin/employee_prices/create_card/en.yml": 661,
	"./admin/employee_prices/table/da.yml": 662,
	"./admin/employee_prices/table/en.yml": 663,
	"./admin/finance_dimension_values/table/da.yml": 664,
	"./admin/finance_dimension_values/table/en.yml": 665,
	"./admin/highscore_class_steps/edit/da.yml": 666,
	"./admin/highscore_class_steps/edit/en.yml": 667,
	"./admin/highscore_class_steps/table/da.yml": 668,
	"./admin/highscore_class_steps/table/en.yml": 669,
	"./admin/highscore_communes/table/da.yml": 670,
	"./admin/highscore_communes/table/en.yml": 671,
	"./admin/highscore_competitions/table/da.yml": 672,
	"./admin/highscore_competitions/table/en.yml": 673,
	"./admin/highscore_generation_surveys/show/da.yml": 674,
	"./admin/highscore_generation_surveys/show/en.yml": 675,
	"./admin/highscore_generation_teams/table/da.yml": 676,
	"./admin/highscore_generation_teams/table/en.yml": 677,
	"./admin/highscore_generations/nav/da.yml": 678,
	"./admin/highscore_generations/nav/en.yml": 679,
	"./admin/highscore_generations/overall_highscore/da.yml": 680,
	"./admin/highscore_generations/overall_highscore/en.yml": 681,
	"./admin/highscore_generations/participants/da.yml": 682,
	"./admin/highscore_generations/participants/en.yml": 683,
	"./admin/highscore_generations/show/da.yml": 684,
	"./admin/highscore_generations/show/en.yml": 685,
	"./admin/highscore_regions/table/da.yml": 686,
	"./admin/highscore_regions/table/en.yml": 687,
	"./admin/highscores/communes/da.yml": 688,
	"./admin/highscores/communes/en.yml": 689,
	"./admin/highscores/competitions/da.yml": 690,
	"./admin/highscores/competitions/en.yml": 691,
	"./admin/highscores/edit/da.yml": 692,
	"./admin/highscores/edit/en.yml": 693,
	"./admin/highscores/excluded_users/da.yml": 694,
	"./admin/highscores/excluded_users/en.yml": 695,
	"./admin/highscores/index/da.yml": 696,
	"./admin/highscores/index/en.yml": 697,
	"./admin/highscores/nav/da.yml": 698,
	"./admin/highscores/nav/en.yml": 699,
	"./admin/highscores/organizations/da.yml": 700,
	"./admin/highscores/organizations/en.yml": 701,
	"./admin/highscores/regions/da.yml": 702,
	"./admin/highscores/regions/en.yml": 703,
	"./admin/highscores/show/da.yml": 704,
	"./admin/highscores/show/en.yml": 705,
	"./admin/invoice_lines/create_card/da.yml": 706,
	"./admin/invoice_lines/create_card/en.yml": 707,
	"./admin/invoice_lines/table/da.yml": 708,
	"./admin/invoice_lines/table/en.yml": 709,
	"./admin/invoices/bottom_bar/da.yml": 710,
	"./admin/invoices/bottom_bar/en.yml": 711,
	"./admin/invoices/create_card/da.yml": 712,
	"./admin/invoices/create_card/en.yml": 713,
	"./admin/invoices/edit/da.yml": 714,
	"./admin/invoices/edit/en.yml": 715,
	"./admin/invoices/expandable_content/da.yml": 716,
	"./admin/invoices/expandable_content/en.yml": 717,
	"./admin/invoices/link/da.yml": 718,
	"./admin/invoices/link/en.yml": 719,
	"./admin/invoices/show/da.yml": 720,
	"./admin/invoices/show/en.yml": 721,
	"./admin/invoices/table/da.yml": 722,
	"./admin/invoices/table/en.yml": 723,
	"./admin/layout/bottom_bar/pagination/da.yml": 724,
	"./admin/layout/bottom_bar/pagination/en.yml": 725,
	"./admin/layout/da.yml": 726,
	"./admin/layout/en.yml": 727,
	"./admin/layout/slide_menu/da.yml": 728,
	"./admin/layout/slide_menu/en.yml": 729,
	"./admin/layout/slide_menu/index/da.yml": 730,
	"./admin/layout/slide_menu/index/en.yml": 731,
	"./admin/layout/top_menu/extended_search/da.yml": 732,
	"./admin/layout/top_menu/extended_search/en.yml": 733,
	"./admin/layout/top_menu/extended_search/group/da.yml": 734,
	"./admin/layout/top_menu/extended_search/group/en.yml": 735,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/da.yml": 736,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/en.yml": 737,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/da.yml": 738,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/en.yml": 739,
	"./admin/layout/top_menu/extended_search/group/rule/da.yml": 740,
	"./admin/layout/top_menu/extended_search/group/rule/en.yml": 741,
	"./admin/layout/top_menu/search_bar/da.yml": 742,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/da.yml": 743,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/en.yml": 744,
	"./admin/layout/top_menu/search_bar/en.yml": 745,
	"./admin/layout/top_menu/user_menu_item/menu/da.yml": 746,
	"./admin/layout/top_menu/user_menu_item/menu/en.yml": 747,
	"./admin/layout_bottom_bar/pagination/da.yml": 748,
	"./admin/layout_bottom_bar/pagination/en.yml": 749,
	"./admin/logs/card/da.yml": 750,
	"./admin/logs/card/en.yml": 751,
	"./admin/logs/details/reimbursement/update/da.yml": 752,
	"./admin/logs/details/reimbursement/update/en.yml": 753,
	"./admin/logs/details/update/da.yml": 754,
	"./admin/logs/details/update/en.yml": 755,
	"./admin/logs/headers/create/da.yml": 756,
	"./admin/logs/headers/create/en.yml": 757,
	"./admin/logs/headers/update/da.yml": 758,
	"./admin/logs/headers/update/en.yml": 759,
	"./admin/logs/index/da.yml": 760,
	"./admin/logs/index/en.yml": 761,
	"./admin/logs/names/activity_participant/da.yml": 762,
	"./admin/logs/names/activity_participant/en.yml": 763,
	"./admin/logs/table/da.yml": 764,
	"./admin/logs/table/en.yml": 765,
	"./admin/messages/create_message_modal/da.yml": 766,
	"./admin/messages/create_message_modal/en.yml": 767,
	"./admin/messages/create_modal/da.yml": 768,
	"./admin/messages/create_modal/en.yml": 769,
	"./admin/messages/table/da.yml": 770,
	"./admin/messages/table/en.yml": 771,
	"./admin/navigations/index/da.yml": 772,
	"./admin/navigations/index/en.yml": 773,
	"./admin/navigations/my_location/da.yml": 774,
	"./admin/navigations/my_location/en.yml": 775,
	"./admin/navigations/show/da.yml": 776,
	"./admin/navigations/show/en.yml": 777,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/da.yml": 778,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/en.yml": 779,
	"./admin/order_lines/table/da.yml": 780,
	"./admin/order_lines/table/en.yml": 781,
	"./admin/orders/bottom_bar/da.yml": 782,
	"./admin/orders/bottom_bar/en.yml": 783,
	"./admin/orders/cancel_button/da.yml": 784,
	"./admin/orders/cancel_button/en.yml": 785,
	"./admin/orders/create_shipments_in_workplace_button/da.yml": 786,
	"./admin/orders/create_shipments_in_workplace_button/en.yml": 787,
	"./admin/orders/finish_process_button/da.yml": 788,
	"./admin/orders/finish_process_button/en.yml": 789,
	"./admin/orders/generate_file_button/da.yml": 790,
	"./admin/orders/generate_file_button/en.yml": 791,
	"./admin/orders/generate_file_for_orders_in_workplace_button/da.yml": 792,
	"./admin/orders/generate_file_for_orders_in_workplace_button/en.yml": 793,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/da.yml": 794,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/en.yml": 795,
	"./admin/orders/index/da.yml": 796,
	"./admin/orders/index/en.yml": 797,
	"./admin/orders/order_lines/da.yml": 798,
	"./admin/orders/order_lines/en.yml": 799,
	"./admin/orders/process_button/da.yml": 800,
	"./admin/orders/process_button/en.yml": 801,
	"./admin/orders/show/da.yml": 802,
	"./admin/orders/show/en.yml": 803,
	"./admin/orders/statistics_modal/da.yml": 804,
	"./admin/orders/statistics_modal/en.yml": 805,
	"./admin/orders/table/da.yml": 806,
	"./admin/orders/table/en.yml": 807,
	"./admin/organizations/edit/da.yml": 808,
	"./admin/organizations/edit/en.yml": 809,
	"./admin/organizations/index/da.yml": 810,
	"./admin/organizations/index/en.yml": 811,
	"./admin/organizations/show/da.yml": 812,
	"./admin/organizations/show/en.yml": 813,
	"./admin/people/table/da.yml": 814,
	"./admin/people/table/en.yml": 815,
	"./admin/person_roles/create_for_contacts_modal/da.yml": 816,
	"./admin/person_roles/create_for_contacts_modal/en.yml": 817,
	"./admin/photo_colors/create_card/da.yml": 818,
	"./admin/photo_colors/create_card/en.yml": 819,
	"./admin/photo_colors/select/da.yml": 820,
	"./admin/photo_colors/select/en.yml": 821,
	"./admin/photo_products/resource_select/da.yml": 822,
	"./admin/photo_products/resource_select/en.yml": 823,
	"./admin/photo_products/table/da.yml": 824,
	"./admin/photo_products/table/en.yml": 825,
	"./admin/photo_qualities/create_card/da.yml": 826,
	"./admin/photo_qualities/create_card/en.yml": 827,
	"./admin/photo_qualities/select/da.yml": 828,
	"./admin/photo_qualities/select/en.yml": 829,
	"./admin/photo_session_group_contacts/table/da.yml": 830,
	"./admin/photo_session_group_contacts/table/en.yml": 831,
	"./admin/photo_sessions/actions_bar/da.yml": 832,
	"./admin/photo_sessions/actions_bar/en.yml": 833,
	"./admin/photo_sessions/bottom_bar/da.yml": 834,
	"./admin/photo_sessions/bottom_bar/en.yml": 835,
	"./admin/photo_sessions/nav/da.yml": 836,
	"./admin/photo_sessions/nav/en.yml": 837,
	"./admin/photo_sessions/row/da.yml": 838,
	"./admin/photo_sessions/row/en.yml": 839,
	"./admin/photo_sessions/show/index/da.yml": 840,
	"./admin/photo_sessions/show/index/en.yml": 841,
	"./admin/photo_sessions/split_view/da.yml": 842,
	"./admin/photo_sessions/split_view/en.yml": 843,
	"./admin/photo_sessions/table/da.yml": 844,
	"./admin/photo_sessions/table/en.yml": 845,
	"./admin/photo_sessions/tree/da.yml": 846,
	"./admin/photo_sessions/tree/en.yml": 847,
	"./admin/photo_sessions/upload_csv_modal/index/da.yml": 848,
	"./admin/photo_sessions/upload_csv_modal/index/en.yml": 849,
	"./admin/photo_sheet_product_sheet_layouts/create_card/da.yml": 850,
	"./admin/photo_sheet_product_sheet_layouts/create_card/en.yml": 851,
	"./admin/photo_sheet_products/edit/da.yml": 852,
	"./admin/photo_sheet_products/edit/en.yml": 853,
	"./admin/photo_sheet_products/select/da.yml": 854,
	"./admin/photo_sheet_products/select/en.yml": 855,
	"./admin/photo_types/create_card/da.yml": 856,
	"./admin/photo_types/create_card/en.yml": 857,
	"./admin/photo_types/select/da.yml": 858,
	"./admin/photo_types/select/en.yml": 859,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/da.yml": 860,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/en.yml": 861,
	"./admin/photos/canvas/da.yml": 862,
	"./admin/photos/canvas/en.yml": 863,
	"./admin/photos/create_card/da.yml": 864,
	"./admin/photos/create_card/en.yml": 865,
	"./admin/photos/table/da.yml": 866,
	"./admin/photos/table/en.yml": 867,
	"./admin/photos/upload_card/da.yml": 868,
	"./admin/photos/upload_card/en.yml": 869,
	"./admin/plans/edit/da.yml": 870,
	"./admin/plans/edit/en.yml": 871,
	"./admin/plans/show/da.yml": 872,
	"./admin/plans/show/en.yml": 873,
	"./admin/plans/subscriptions/da.yml": 874,
	"./admin/plans/subscriptions/en.yml": 875,
	"./admin/plans/table/da.yml": 876,
	"./admin/plans/table/en.yml": 877,
	"./admin/products/select/da.yml": 878,
	"./admin/products/select/en.yml": 879,
	"./admin/products/show/da.yml": 880,
	"./admin/products/show/en.yml": 881,
	"./admin/reimbursement/table/da.yml": 882,
	"./admin/reimbursement/table/en.yml": 883,
	"./admin/reimbursement_attachments/expandable_content/da.yml": 884,
	"./admin/reimbursement_attachments/expandable_content/description/da.yml": 885,
	"./admin/reimbursement_attachments/expandable_content/description/en.yml": 886,
	"./admin/reimbursement_attachments/expandable_content/en.yml": 887,
	"./admin/reimbursement_attachments/table/da.yml": 888,
	"./admin/reimbursement_attachments/table/en.yml": 889,
	"./admin/reimbursements/attachments/da.yml": 890,
	"./admin/reimbursements/attachments/en.yml": 891,
	"./admin/reimbursements/bottom_bar/da.yml": 892,
	"./admin/reimbursements/bottom_bar/en.yml": 893,
	"./admin/reimbursements/expense/da.yml": 894,
	"./admin/reimbursements/expense/en.yml": 895,
	"./admin/reimbursements/expense_sum/index/da.yml": 896,
	"./admin/reimbursements/expense_sum/index/en.yml": 897,
	"./admin/reimbursements/index/da.yml": 898,
	"./admin/reimbursements/index/en.yml": 899,
	"./admin/reimbursements/nav/da.yml": 900,
	"./admin/reimbursements/nav/en.yml": 901,
	"./admin/reimbursements/process/da.yml": 902,
	"./admin/reimbursements/process/en.yml": 903,
	"./admin/reimbursements/time/da.yml": 904,
	"./admin/reimbursements/time/en.yml": 905,
	"./admin/reimbursements/travel/da.yml": 906,
	"./admin/reimbursements/travel/en.yml": 907,
	"./admin/reimbursements/travel_sum/index/da.yml": 908,
	"./admin/reimbursements/travel_sum/index/en.yml": 909,
	"./admin/required_metadata/card/da.yml": 910,
	"./admin/required_metadata/card/en.yml": 911,
	"./admin/role_abilities/edit/da.yml": 912,
	"./admin/role_abilities/edit/en.yml": 913,
	"./admin/role_abilities/lock_icon/da.yml": 914,
	"./admin/role_abilities/lock_icon/en.yml": 915,
	"./admin/role_ability_groups/lock_icon/da.yml": 916,
	"./admin/role_ability_groups/lock_icon/en.yml": 917,
	"./admin/roles/abilities/da.yml": 918,
	"./admin/roles/abilities/en.yml": 919,
	"./admin/roles/ability_groups/da.yml": 920,
	"./admin/roles/ability_groups/en.yml": 921,
	"./admin/roles/edit/da.yml": 922,
	"./admin/roles/edit/en.yml": 923,
	"./admin/roles/show/da.yml": 924,
	"./admin/roles/show/en.yml": 925,
	"./admin/routes/contact_relationships/edit/da.yml": 926,
	"./admin/routes/contact_relationships/edit/en.yml": 927,
	"./admin/routes/webshop/photo_products/da.yml": 928,
	"./admin/routes/webshop/photo_products/en.yml": 929,
	"./admin/routes/webshop/tenant_photo_products/da.yml": 930,
	"./admin/routes/webshop/tenant_photo_products/en.yml": 931,
	"./admin/school_classes/index/da.yml": 932,
	"./admin/school_classes/index/en.yml": 933,
	"./admin/school_classes/table/da.yml": 934,
	"./admin/school_classes/table/en.yml": 935,
	"./admin/school_years/index/da.yml": 936,
	"./admin/school_years/index/en.yml": 937,
	"./admin/sending_rules/create_card/da.yml": 938,
	"./admin/sending_rules/create_card/en.yml": 939,
	"./admin/sending_rules/table/da.yml": 940,
	"./admin/sending_rules/table/en.yml": 941,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/da.yml": 942,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/en.yml": 943,
	"./admin/sheet_layouts/create_card/da.yml": 944,
	"./admin/sheet_layouts/create_card/en.yml": 945,
	"./admin/sheet_layouts/select/da.yml": 946,
	"./admin/sheet_layouts/select/en.yml": 947,
	"./admin/sheet_layouts/show/da.yml": 948,
	"./admin/sheet_layouts/show/duplicate_box_icon/da.yml": 949,
	"./admin/sheet_layouts/show/duplicate_box_icon/en.yml": 950,
	"./admin/sheet_layouts/show/en.yml": 951,
	"./admin/sheet_layouts/show/remove_box_icon/da.yml": 952,
	"./admin/sheet_layouts/show/remove_box_icon/en.yml": 953,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/da.yml": 954,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/en.yml": 955,
	"./admin/sheet_sizes/create_card/da.yml": 956,
	"./admin/sheet_sizes/create_card/en.yml": 957,
	"./admin/sheet_sizes/select/da.yml": 958,
	"./admin/sheet_sizes/select/en.yml": 959,
	"./admin/show_box_attributes/form/da.yml": 960,
	"./admin/show_box_attributes/form/en.yml": 961,
	"./admin/show_boxes/form/da.yml": 962,
	"./admin/show_boxes/form/en.yml": 963,
	"./admin/show_boxes/partial/attribute/da.yml": 964,
	"./admin/show_boxes/partial/attribute/en.yml": 965,
	"./admin/show_boxes/partial/box/da.yml": 966,
	"./admin/show_boxes/partial/box/en.yml": 967,
	"./admin/show_boxes/partial/da.yml": 968,
	"./admin/show_boxes/partial/en.yml": 969,
	"./admin/steps/da.yml": 970,
	"./admin/steps/edit/da.yml": 971,
	"./admin/steps/edit/en.yml": 972,
	"./admin/steps/element/da.yml": 973,
	"./admin/steps/element/en.yml": 974,
	"./admin/steps/element_feedback/da.yml": 975,
	"./admin/steps/element_feedback/en.yml": 976,
	"./admin/steps/element_feedback_option/da.yml": 977,
	"./admin/steps/element_feedback_option/en.yml": 978,
	"./admin/steps/elements/da.yml": 979,
	"./admin/steps/elements/en.yml": 980,
	"./admin/steps/en.yml": 981,
	"./admin/steps/show/da.yml": 982,
	"./admin/steps/show/en.yml": 983,
	"./admin/steps/table/da.yml": 984,
	"./admin/steps/table/en.yml": 985,
	"./admin/student_council_memberships/edit/da.yml": 986,
	"./admin/student_council_memberships/edit/en.yml": 987,
	"./admin/subjects/select/da.yml": 988,
	"./admin/subjects/select/en.yml": 989,
	"./admin/subscription_periods/table/da.yml": 990,
	"./admin/subscription_periods/table/en.yml": 991,
	"./admin/subscription_renewal_generations/show/da.yml": 992,
	"./admin/subscription_renewal_generations/show/en.yml": 993,
	"./admin/subscription_renewal_generations/table/da.yml": 994,
	"./admin/subscription_renewal_generations/table/en.yml": 995,
	"./admin/subscriptions/show/da.yml": 996,
	"./admin/subscriptions/show/en.yml": 997,
	"./admin/subscriptions/table/da.yml": 998,
	"./admin/subscriptions/table/en.yml": 999,
	"./admin/supplier_supported_photo_qualities/create_card/da.yml": 1000,
	"./admin/supplier_supported_photo_qualities/create_card/en.yml": 1001,
	"./admin/supplier_supported_sheets/create_card/da.yml": 1002,
	"./admin/supplier_supported_sheets/create_card/en.yml": 1003,
	"./admin/suppliers/select/da.yml": 1004,
	"./admin/suppliers/select/en.yml": 1005,
	"./admin/survey_judges/row/da.yml": 1006,
	"./admin/survey_judges/row/en.yml": 1007,
	"./admin/surveys/activation_button/da.yml": 1008,
	"./admin/surveys/activation_button/en.yml": 1009,
	"./admin/surveys/edit/da.yml": 1010,
	"./admin/surveys/edit/en.yml": 1011,
	"./admin/surveys/index/da.yml": 1012,
	"./admin/surveys/index/en.yml": 1013,
	"./admin/surveys/nav/da.yml": 1014,
	"./admin/surveys/nav/en.yml": 1015,
	"./admin/surveys/show/da.yml": 1016,
	"./admin/surveys/show/en.yml": 1017,
	"./admin/surveys/survey_details/da.yml": 1018,
	"./admin/surveys/survey_details/en.yml": 1019,
	"./admin/surveys/survey_steps/da.yml": 1020,
	"./admin/surveys/survey_steps/en.yml": 1021,
	"./admin/surveys/table/da.yml": 1022,
	"./admin/surveys/table/en.yml": 1023,
	"./admin/taggings/taggable/da.yml": 1024,
	"./admin/taggings/taggable/en.yml": 1025,
	"./admin/taggings/taggable/form/da.yml": 1026,
	"./admin/taggings/taggable/form/en.yml": 1027,
	"./admin/tags/workplace_merge_button/da.yml": 1028,
	"./admin/tags/workplace_merge_button/en.yml": 1029,
	"./admin/team_surveys/bottom_bar/da.yml": 1030,
	"./admin/team_surveys/bottom_bar/en.yml": 1031,
	"./admin/team_surveys/index/da.yml": 1032,
	"./admin/team_surveys/index/en.yml": 1033,
	"./admin/team_surveys/show/da.yml": 1034,
	"./admin/team_surveys/show/en.yml": 1035,
	"./admin/team_surveys/show/user_step/da.yml": 1036,
	"./admin/team_surveys/show/user_step/en.yml": 1037,
	"./admin/team_surveys/table/da.yml": 1038,
	"./admin/team_surveys/table/en.yml": 1039,
	"./admin/team_users/edit/da.yml": 1040,
	"./admin/team_users/edit/en.yml": 1041,
	"./admin/team_users/show/da.yml": 1042,
	"./admin/team_users/show/en.yml": 1043,
	"./admin/teams/edit/da.yml": 1044,
	"./admin/teams/edit/en.yml": 1045,
	"./admin/teams/index/da.yml": 1046,
	"./admin/teams/index/en.yml": 1047,
	"./admin/teams/show/da.yml": 1048,
	"./admin/teams/show/en.yml": 1049,
	"./admin/templates/create_card/da.yml": 1050,
	"./admin/templates/create_card/en.yml": 1051,
	"./admin/tenant_domains/row/da.yml": 1052,
	"./admin/tenant_domains/row/en.yml": 1053,
	"./admin/tenant_domains/select/da.yml": 1054,
	"./admin/tenant_domains/select/en.yml": 1055,
	"./admin/tenant_photo_products/create_card/da.yml": 1056,
	"./admin/tenant_photo_products/create_card/en.yml": 1057,
	"./admin/tenant_photo_products/visible_in_shop/da.yml": 1058,
	"./admin/tenant_photo_products/visible_in_shop/en.yml": 1059,
	"./admin/tenants/create_card/da.yml": 1060,
	"./admin/tenants/create_card/en.yml": 1061,
	"./admin/tenants/integrations/bambora/da.yml": 1062,
	"./admin/tenants/integrations/bambora/en.yml": 1063,
	"./admin/tenants/integrations/inventio/da.yml": 1064,
	"./admin/tenants/integrations/inventio/en.yml": 1065,
	"./admin/tenants/integrations/nav/da.yml": 1066,
	"./admin/tenants/integrations/nav/en.yml": 1067,
	"./admin/tenants/integrations/shipmondo/da.yml": 1068,
	"./admin/tenants/integrations/shipmondo/en.yml": 1069,
	"./admin/tenants/nav/da.yml": 1070,
	"./admin/tenants/nav/en.yml": 1071,
	"./admin/tenants/setup/da.yml": 1072,
	"./admin/tenants/setup/en.yml": 1073,
	"./admin/toggle_eye_button/da.yml": 1074,
	"./admin/toggle_eye_button/en.yml": 1075,
	"./admin/user_elements/answer/da.yml": 1076,
	"./admin/user_elements/answer/en.yml": 1077,
	"./admin/user_elements/edit/da.yml": 1078,
	"./admin/user_elements/edit/en.yml": 1079,
	"./admin/users/edit/da.yml": 1080,
	"./admin/users/edit/en.yml": 1081,
	"./admin/users/index/da.yml": 1082,
	"./admin/users/index/en.yml": 1083,
	"./admin/users/passwords/edit/da.yml": 1084,
	"./admin/users/passwords/edit/en.yml": 1085,
	"./admin/users/passwords/new/da.yml": 1086,
	"./admin/users/passwords/new/en.yml": 1087,
	"./admin/users/show/da.yml": 1088,
	"./admin/users/show/en.yml": 1089,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/da.yml": 1090,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/en.yml": 1091,
	"./admin/workplaces/bottom_bar/da.yml": 1092,
	"./admin/workplaces/bottom_bar/en.yml": 1093,
	"./admin/workplaces/bottom_bar/index/da.yml": 1094,
	"./admin/workplaces/bottom_bar/index/en.yml": 1095,
	"./agenda_item_elements/edit/audio/da.yml": 1096,
	"./agenda_item_elements/edit/audio/en.yml": 1097,
	"./agenda_item_elements/edit/document/da.yml": 1098,
	"./agenda_item_elements/edit/document/en.yml": 1099,
	"./agenda_item_elements/edit/image/da.yml": 1100,
	"./agenda_item_elements/edit/image/en.yml": 1101,
	"./agendas/actions_bar/da.yml": 1102,
	"./agendas/actions_bar/en.yml": 1103,
	"./agendas/live/da.yml": 1104,
	"./agendas/live/en.yml": 1105,
	"./bank_accounts/account_type_select/da.yml": 1106,
	"./bank_accounts/account_type_select/en.yml": 1107,
	"./block_ui/da.yml": 1108,
	"./block_ui/en.yml": 1109,
	"./buttons/table_expand/da.yml": 1110,
	"./buttons/table_expand/en.yml": 1111,
	"./classSteps/select/da.yml": 1112,
	"./classSteps/select/en.yml": 1113,
	"./competitions/choose_survey/da.yml": 1114,
	"./competitions/choose_survey/en.yml": 1115,
	"./competitions/choose_team/da.yml": 1116,
	"./competitions/choose_team/en.yml": 1117,
	"./competitions/choose_team_type/da.yml": 1118,
	"./competitions/choose_team_type/en.yml": 1119,
	"./competitions/index/da.yml": 1120,
	"./competitions/index/en.yml": 1121,
	"./competitions/show/da.yml": 1122,
	"./competitions/show/en.yml": 1123,
	"./competitions_choose_team/da.yml": 1124,
	"./competitions_choose_team/en.yml": 1125,
	"./components/responsive_nav/da.yml": 1126,
	"./components/responsive_nav/en.yml": 1127,
	"./confirm_dialog/da.yml": 1128,
	"./confirm_dialog/en.yml": 1129,
	"./contact_merge_requests/confirm_merge_request/da.yml": 1130,
	"./contact_merge_requests/confirm_merge_request/en.yml": 1131,
	"./contact_merge_requests/merge_request/da.yml": 1132,
	"./contact_merge_requests/merge_request/en.yml": 1133,
	"./contacts/select/da.yml": 1134,
	"./contacts/select/en.yml": 1135,
	"./election/school_elections/new/da.yml": 1136,
	"./election/school_elections/new/en.yml": 1137,
	"./element_types/da.yml": 1138,
	"./element_types/en.yml": 1139,
	"./feedback_assignments/show/da.yml": 1140,
	"./feedback_assignments/show/en.yml": 1141,
	"./feedback_steps/da.yml": 1142,
	"./feedback_steps/dropdown/da.yml": 1143,
	"./feedback_steps/dropdown/en.yml": 1144,
	"./feedback_steps/edit/da.yml": 1145,
	"./feedback_steps/edit/en.yml": 1146,
	"./feedback_steps/en.yml": 1147,
	"./flash_message/da.yml": 1148,
	"./flash_message/en.yml": 1149,
	"./forms/attachment_input/da.yml": 1150,
	"./forms/attachment_input/en.yml": 1151,
	"./forms/image_input/da.yml": 1152,
	"./forms/image_input/en.yml": 1153,
	"./global/da.yml": 1154,
	"./global/en.yml": 1155,
	"./jobler/job_status/da.yml": 1156,
	"./jobler/job_status/en.yml": 1157,
	"./layout/da.yml": 1158,
	"./layout/en.yml": 1159,
	"./layout/no_access/da.yml": 1160,
	"./layout/no_access/en.yml": 1161,
	"./layout/not_found/da.yml": 1162,
	"./layout/not_found/en.yml": 1163,
	"./layout/require_two_factor_authentication_proxy/da.yml": 1164,
	"./layout/require_two_factor_authentication_proxy/en.yml": 1165,
	"./layout/top_menu/user_meun_item/menu/da.yml": 1166,
	"./layout/top_menu/user_meun_item/menu/en.yml": 1167,
	"./layout/top_nav/da.yml": 1168,
	"./layout/top_nav/en.yml": 1169,
	"./layout/top_nav/notifications_modal/da.yml": 1170,
	"./layout/top_nav/notifications_modal/en.yml": 1171,
	"./live_streaming_feeds/broadcaster/index/da.yml": 1172,
	"./live_streaming_feeds/broadcaster/index/en.yml": 1173,
	"./live_streaming_feeds/broadcaster/settings/da.yml": 1174,
	"./live_streaming_feeds/broadcaster/settings/en.yml": 1175,
	"./live_streaming_feeds/viewer/da.yml": 1176,
	"./live_streaming_feeds/viewer/en.yml": 1177,
	"./merfoto/albums/index/da.yml": 1178,
	"./merfoto/albums/index/en.yml": 1179,
	"./merfoto/basket/basket_item_card/index/da.yml": 1180,
	"./merfoto/basket/basket_item_card/index/en.yml": 1181,
	"./merfoto/basket/da.yml": 1182,
	"./merfoto/basket/destroy_order_line_button/da.yml": 1183,
	"./merfoto/basket/destroy_order_line_button/en.yml": 1184,
	"./merfoto/basket/en.yml": 1185,
	"./merfoto/basket/quantity/da.yml": 1186,
	"./merfoto/basket/quantity/en.yml": 1187,
	"./merfoto/basket/unique_photos_label/da.yml": 1188,
	"./merfoto/basket/unique_photos_label/en.yml": 1189,
	"./merfoto/checkout/completed/da.yml": 1190,
	"./merfoto/checkout/completed/en.yml": 1191,
	"./merfoto/checkout/confirm/da.yml": 1192,
	"./merfoto/checkout/confirm/en.yml": 1193,
	"./merfoto/checkout/customer_information/da.yml": 1194,
	"./merfoto/checkout/customer_information/en.yml": 1195,
	"./merfoto/checkout/delivery/da.yml": 1196,
	"./merfoto/checkout/delivery/en.yml": 1197,
	"./merfoto/checkout/navbar/da.yml": 1198,
	"./merfoto/checkout/navbar/en.yml": 1199,
	"./merfoto/checkout/payment/da.yml": 1200,
	"./merfoto/checkout/payment/en.yml": 1201,
	"./merfoto/components/order_lines/edit/resources/bundle/da.yml": 1202,
	"./merfoto/components/order_lines/edit/resources/bundle/en.yml": 1203,
	"./merfoto/components/sheet-layouts/presentation/da.yml": 1204,
	"./merfoto/components/sheet-layouts/presentation/en.yml": 1205,
	"./merfoto/downloads/da.yml": 1206,
	"./merfoto/downloads/en.yml": 1207,
	"./merfoto/layout/footer/da.yml": 1208,
	"./merfoto/layout/footer/en.yml": 1209,
	"./merfoto/layout/footer/index/da.yml": 1210,
	"./merfoto/layout/footer/index/en.yml": 1211,
	"./merfoto/layout/index/da.yml": 1212,
	"./merfoto/layout/index/en.yml": 1213,
	"./merfoto/layout/top_bar/index/da.yml": 1214,
	"./merfoto/layout/top_bar/index/en.yml": 1215,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/da.yml": 1216,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/en.yml": 1217,
	"./merfoto/layout/topbar/index/da.yml": 1218,
	"./merfoto/layout/topbar/index/en.yml": 1219,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/da.yml": 1220,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/en.yml": 1221,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/da.yml": 1222,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/en.yml": 1223,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/da.yml": 1224,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/en.yml": 1225,
	"./merfoto/order_lines/edit/submit_image_button/da.yml": 1226,
	"./merfoto/order_lines/edit/submit_image_button/en.yml": 1227,
	"./merfoto/orders/da.yml": 1228,
	"./merfoto/orders/en.yml": 1229,
	"./merfoto/orders/table/da.yml": 1230,
	"./merfoto/orders/table/en.yml": 1231,
	"./merfoto/orders/total_with_delivery/da.yml": 1232,
	"./merfoto/orders/total_with_delivery/en.yml": 1233,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/da.yml": 1234,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/en.yml": 1235,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/da.yml": 1236,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/en.yml": 1237,
	"./merfoto/photo_session_group_contacts/select_album/da.yml": 1238,
	"./merfoto/photo_session_group_contacts/select_album/en.yml": 1239,
	"./merfoto/photo_session_groups/card/index/da.yml": 1240,
	"./merfoto/photo_session_groups/card/index/en.yml": 1241,
	"./merfoto/photo_session_groups/card/photo_card/da.yml": 1242,
	"./merfoto/photo_session_groups/card/photo_card/en.yml": 1243,
	"./merfoto/photo_sheet_product_order_lines/edit/da.yml": 1244,
	"./merfoto/photo_sheet_product_order_lines/edit/en.yml": 1245,
	"./merfoto/routes/albums/da.yml": 1246,
	"./merfoto/routes/albums/en.yml": 1247,
	"./merfoto/routes/welcome/da.yml": 1248,
	"./merfoto/routes/welcome/en.yml": 1249,
	"./merfoto/tenant_photo_products/add_to_basket_button/da.yml": 1250,
	"./merfoto/tenant_photo_products/add_to_basket_button/en.yml": 1251,
	"./merfoto/tenant_photo_products_with_photos/card/index/da.yml": 1252,
	"./merfoto/tenant_photo_products_with_photos/card/index/en.yml": 1253,
	"./merfoto/tenant_photo_products_with_photos/index/da.yml": 1254,
	"./merfoto/tenant_photo_products_with_photos/index/en.yml": 1255,
	"./merfoto/token/da.yml": 1256,
	"./merfoto/token/en.yml": 1257,
	"./merfoto/users/passwords/new/da.yml": 1258,
	"./merfoto/users/passwords/new/en.yml": 1259,
	"./merfoto/welcome/da.yml": 1260,
	"./merfoto/welcome/en.yml": 1261,
	"./merfoto/welcome_top_container/index/da.yml": 1262,
	"./merfoto/welcome_top_container/index/en.yml": 1263,
	"./models_table/add_column_button/da.yml": 1264,
	"./models_table/add_column_button/en.yml": 1265,
	"./models_table/columns_drop_down/da.yml": 1266,
	"./models_table/columns_drop_down/en.yml": 1267,
	"./navigations/index/da.yml": 1268,
	"./navigations/index/en.yml": 1269,
	"./navigations/show/da.yml": 1270,
	"./navigations/show/en.yml": 1271,
	"./nemoa/activities/elections/election/da.yml": 1272,
	"./nemoa/activities/elections/election/en.yml": 1273,
	"./nemoa/activities/index/card/participant_state_overlay/index/da.yml": 1274,
	"./nemoa/activities/index/card/participant_state_overlay/index/en.yml": 1275,
	"./nemoa/activities/mine/index/da.yml": 1276,
	"./nemoa/activities/mine/index/en.yml": 1277,
	"./nemoa/activities/nav/index/da.yml": 1278,
	"./nemoa/activities/nav/index/en.yml": 1279,
	"./nemoa/activities/required_metadata_proxy_with_surveys/da.yml": 1280,
	"./nemoa/activities/required_metadata_proxy_with_surveys/en.yml": 1281,
	"./nemoa/activities/show/elections/da.yml": 1282,
	"./nemoa/activities/show/elections/en.yml": 1283,
	"./nemoa/activities/show/elections/index/da.yml": 1284,
	"./nemoa/activities/show/elections/index/en.yml": 1285,
	"./nemoa/activities/show/index/da.yml": 1286,
	"./nemoa/activities/show/index/en.yml": 1287,
	"./nemoa/activities/show/live/da.yml": 1288,
	"./nemoa/activities/show/live/en.yml": 1289,
	"./nemoa/activities/show/nav/da.yml": 1290,
	"./nemoa/activities/show/nav/en.yml": 1291,
	"./nemoa/activities/show/politics/da.yml": 1292,
	"./nemoa/activities/show/politics/en.yml": 1293,
	"./nemoa/components/user_steps/element_types/question_sentence/da.yml": 1294,
	"./nemoa/components/user_steps/element_types/question_sentence/en.yml": 1295,
	"./nemoa/layout/slide_menu/index/da.yml": 1296,
	"./nemoa/layout/slide_menu/index/en.yml": 1297,
	"./nemoa/layout/top_menu/index/da.yml": 1298,
	"./nemoa/layout/top_menu/index/en.yml": 1299,
	"./nemoa/layout/top_menu/user_menu_item/index/da.yml": 1300,
	"./nemoa/layout/top_menu/user_menu_item/index/en.yml": 1301,
	"./nemoa/required_metadata/required_metadata_proxy/da.yml": 1302,
	"./nemoa/required_metadata/required_metadata_proxy/en.yml": 1303,
	"./nemoa/user_steps/edit/da.yml": 1304,
	"./nemoa/user_steps/edit/en.yml": 1305,
	"./nemoa/users/edit/form/index/da.yml": 1306,
	"./nemoa/users/edit/form/index/en.yml": 1307,
	"./nemoa/users/passwords/new/da.yml": 1308,
	"./nemoa/users/passwords/new/en.yml": 1309,
	"./nemoa_select/da.yml": 1310,
	"./nemoa_select/en.yml": 1311,
	"./notifications/types/team_application_accepted/da.yml": 1312,
	"./notifications/types/team_application_accepted/en.yml": 1313,
	"./notifications/types/team_application_declined/da.yml": 1314,
	"./notifications/types/team_application_declined/en.yml": 1315,
	"./notifications/types/team_survey_started/da.yml": 1316,
	"./notifications/types/team_survey_started/en.yml": 1317,
	"./organizations/select/da.yml": 1318,
	"./organizations/select/en.yml": 1319,
	"./preview/da.yml": 1320,
	"./preview/en.yml": 1321,
	"./proposal_types/presenter_card/da.yml": 1322,
	"./proposal_types/presenter_card/en.yml": 1323,
	"./registrations/form/da.yml": 1324,
	"./registrations/form/en.yml": 1325,
	"./reimbursements/attachments/create_card/da.yml": 1326,
	"./reimbursements/attachments/create_card/en.yml": 1327,
	"./reimbursements/create_card/da.yml": 1328,
	"./reimbursements/create_card/en.yml": 1329,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/da.yml": 1330,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/en.yml": 1331,
	"./reimbursements/create_card/extended_form/save_button/da.yml": 1332,
	"./reimbursements/create_card/extended_form/save_button/en.yml": 1333,
	"./reimbursements/create_card/index/da.yml": 1334,
	"./reimbursements/create_card/index/en.yml": 1335,
	"./reimbursements/documents/da.yml": 1336,
	"./reimbursements/documents/en.yml": 1337,
	"./reimbursements/documents_button/carousel/da.yml": 1338,
	"./reimbursements/documents_button/carousel/en.yml": 1339,
	"./reimbursements/expenses/index/da.yml": 1340,
	"./reimbursements/expenses/index/en.yml": 1341,
	"./reimbursements/index/da.yml": 1342,
	"./reimbursements/index/en.yml": 1343,
	"./reimbursements/index/time_sum/da.yml": 1344,
	"./reimbursements/index/time_sum/en.yml": 1345,
	"./reimbursements/table/da.yml": 1346,
	"./reimbursements/table/en.yml": 1347,
	"./reimbursements/time/da.yml": 1348,
	"./reimbursements/time/en.yml": 1349,
	"./reimbursements/travel/index/da.yml": 1350,
	"./reimbursements/travel/index/en.yml": 1351,
	"./roles/select/da.yml": 1352,
	"./roles/select/en.yml": 1353,
	"./save_modes/da.yml": 1354,
	"./save_modes/en.yml": 1355,
	"./school_classes/select/da.yml": 1356,
	"./school_classes/select/en.yml": 1357,
	"./sessions/new/da.yml": 1358,
	"./sessions/new/en.yml": 1359,
	"./sessions/new/index/da.yml": 1360,
	"./sessions/new/index/en.yml": 1361,
	"./sessions/new/one_time_password_prompt/da.yml": 1362,
	"./sessions/new/one_time_password_prompt/en.yml": 1363,
	"./sessions/new/uni_login_image_button/da.yml": 1364,
	"./sessions/new/uni_login_image_button/en.yml": 1365,
	"./shared/create_card/da.yml": 1366,
	"./shared/create_card/en.yml": 1367,
	"./shared/da.yml": 1368,
	"./shared/en.yml": 1369,
	"./shared/preview/da.yml": 1370,
	"./shared/preview/en.yml": 1371,
	"./shared/preview/index/da.yml": 1372,
	"./shared/preview/index/en.yml": 1373,
	"./shared/state_selector/da.yml": 1374,
	"./shared/state_selector/en.yml": 1375,
	"./shared/table/index/da.yml": 1376,
	"./shared/table/index/en.yml": 1377,
	"./shared/table/row/da.yml": 1378,
	"./shared/table/row/en.yml": 1379,
	"./shared/tree/index/da.yml": 1380,
	"./shared/tree/index/en.yml": 1381,
	"./shared/tree/node/da.yml": 1382,
	"./shared/tree/node/en.yml": 1383,
	"./sheet_layouts/presentation/index/da.yml": 1384,
	"./sheet_layouts/presentation/index/en.yml": 1385,
	"./steps/da.yml": 1386,
	"./steps/en.yml": 1387,
	"./surveys/list_partial/da.yml": 1388,
	"./surveys/list_partial/en.yml": 1389,
	"./surveys/show/da.yml": 1390,
	"./surveys/show/en.yml": 1391,
	"./team_surveys/complete/da.yml": 1392,
	"./team_surveys/complete/en.yml": 1393,
	"./team_surveys/edit/da.yml": 1394,
	"./team_surveys/edit/en.yml": 1395,
	"./team_surveys/feedback_states/da.yml": 1396,
	"./team_surveys/feedback_states/en.yml": 1397,
	"./team_surveys/time_used/da.yml": 1398,
	"./team_surveys/time_used/en.yml": 1399,
	"./teams/edit/da.yml": 1400,
	"./teams/edit/en.yml": 1401,
	"./teams/selector/choose_team/da.yml": 1402,
	"./teams/selector/choose_team/en.yml": 1403,
	"./teams/show/da.yml": 1404,
	"./teams/show/en.yml": 1405,
	"./tenants/select/da.yml": 1406,
	"./tenants/select/en.yml": 1407,
	"./tenants/setup/da.yml": 1408,
	"./tenants/setup/en.yml": 1409,
	"./uni_logins/new/da.yml": 1410,
	"./uni_logins/new/en.yml": 1411,
	"./uni_logins/successful/da.yml": 1412,
	"./uni_logins/successful/en.yml": 1413,
	"./upload_button/index/da.yml": 1414,
	"./upload_button/index/en.yml": 1415,
	"./upload_button_with_preview/index/da.yml": 1416,
	"./upload_button_with_preview/index/en.yml": 1417,
	"./user_steps/edit/da.yml": 1418,
	"./user_steps/edit/en.yml": 1419,
	"./user_steps/element_types/question_dropdown/da.yml": 1420,
	"./user_steps/element_types/question_dropdown/en.yml": 1421,
	"./user_steps/element_types/question_file/index/da.yml": 1422,
	"./user_steps/element_types/question_file/index/en.yml": 1423,
	"./users/confirmation/da.yml": 1424,
	"./users/confirmation/en.yml": 1425,
	"./users/confirmation/index/da.yml": 1426,
	"./users/confirmation/index/en.yml": 1427,
	"./users/confirmation/new/da.yml": 1428,
	"./users/confirmation/new/en.yml": 1429,
	"./users/confirmations/new/da.yml": 1430,
	"./users/confirmations/new/en.yml": 1431,
	"./users/consent/index/da.yml": 1432,
	"./users/consent/index/en.yml": 1433,
	"./users/edit/form/da.yml": 1434,
	"./users/edit/form/en.yml": 1435,
	"./users/edit/form/index/da.yml": 1436,
	"./users/edit/form/index/en.yml": 1437,
	"./users/edit/form/relatives/da.yml": 1438,
	"./users/edit/form/relatives/en.yml": 1439,
	"./users/edit/form/two_factor_authentication/da.yml": 1440,
	"./users/edit/form/two_factor_authentication/en.yml": 1441,
	"./users/edit/school/da.yml": 1442,
	"./users/edit/school/en.yml": 1443,
	"./users/notifications/partial/da.yml": 1444,
	"./users/notifications/partial/en.yml": 1445,
	"./users/passwords/edit/da.yml": 1446,
	"./users/passwords/edit/en.yml": 1447,
	"./users/passwords/edit/index/da.yml": 1448,
	"./users/passwords/edit/index/en.yml": 1449,
	"./users/passwords/new/da.yml": 1450,
	"./users/passwords/new/en.yml": 1451,
	"./users/settings/da.yml": 1452,
	"./users/settings/en.yml": 1453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;